import { AccordionDetails, AccordionSummary } from '@material-ui/core'
import React, { useState } from 'react'
import ReactPlayer from 'react-player'
import Button from '../../../../../../../../../Components/Buttons/Button'
import { S05, Text } from '../../../../../../../../../Styles/typography'
import { RequestTabEl } from '../Elements'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import BatchTimingsStore from '../../../Stores/BatchTimingsStore'
import Avatar from '../../../../../../../../../Components/Avatar'

function RequestTab({
  data: { id, name, cover, message, chatId, auditionVideo, chatMessageId },
}) {
  const [loading, setLoading] = useState(false)

  const { processRegistration } = BatchTimingsStore.useContainer()

  return (
    <RequestTabEl img={cover}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Avatar
          image={cover}
          name={name}
          size={3}
          variant='rounded'
          className={'avatar'}
        />
        <Text>{name}</Text>
      </AccordionSummary>
      <AccordionDetails>
        {auditionVideo && (
          <>
            <Text>
              Audition Video:{' '}
              {/* <Button name={"Download"} onClick={() => {}} type={"primary"} /> */}
            </Text>
            <ReactPlayer
              className='audition-video'
              width='100%'
              height='100%'
              url={auditionVideo}
              controls
            />
          </>
        )}

        <Text>Message:</Text>
        <S05>{message}</S05>

        <div className='buttons'>
          <Button
            onClick={async () => {
              setLoading(true)
              await processRegistration(id, {
                chatId,
                note: 'Rejected',
                status: 'REJECTED',
                chatMessageId,
              })
              setLoading(false)
            }}
            type='secondary small'
            name={'Reject'}
            disabled={loading}
            loading={loading}
            withConfirmation
          />
          <Button
            onClick={async () => {
              setLoading(true)
              await processRegistration(id, {
                chatId,
                status: 'APPROVED',
                note: 'Approved',
                chatMessageId,
              })
              setLoading(false)
            }}
            type='primary'
            name={'Accept'}
            disabled={loading}
            loading={loading}
            withConfirmation
          />
        </div>
      </AccordionDetails>
    </RequestTabEl>
  )
}

export default RequestTab
